import { MarkdownContentPage } from "@/components/content/MarkdownContentPage";
import { contentPages } from "@/content/content-pages";

export default function TermsOfServicePage() {
  return <MarkdownContentPage content={contentPages["terms-of-service"]} />;
}
